import { Drawer } from "antd";
import { Formik } from "formik";
import { get } from "lodash";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";
import LeadTypologyMappingCard from "./Detail/LeadTypologyMappingCard";
import Fields from "./Fields";
import { sourceHasStarted, toSourceFormValues } from "./form";
import validation from "./validation";

const FormDrawer = ({ source, onSubmit, onClose, submitting }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.SOURCE);
  const FORM = t("FORM", { returnObjects: true });
  const isEdition = Boolean(source && source.id);
  const [isMappingAmbiguous, setIsMappingAmbiguous] = useState(false);
  const initialValues = useMemo(
    () => toSourceFormValues(source || {}),
    [source],
  );

  return (
    <Drawer
      open
      className="drawer__area"
      title={isEdition ? t("DETAIL.TITLE") : t("CREATE.TITLE")}
      width={isEdition ? 720 : 500}
      onClose={onClose}
      placement="right"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values) =>
          onSubmit(values, { initial: isEdition ? initialValues : null })
        }
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
          { lockStartDate: isEdition },
        )}
      >
        {({ handleSubmit, setFieldValue, values, ...formProps }) => (
          <>
            <Fields
              formProps={formProps}
              values={values}
              setFieldValue={setFieldValue}
              FORM={FORM}
              lockStartDate={isEdition}
              lockProcess={isEdition && sourceHasStarted(source)}
            />
            {isEdition && (
              <div className="mt-16">
                <LeadTypologyMappingCard
                  sourceId={source.id}
                  nameSpace={NAME_SPACES.PRIVATE.ADMIN.LEAD_TYPOLOGY}
                  value={values.leadTypologyMapping}
                  savedValue={get(source, "leadTypologyMapping")}
                  onChange={(mapping) =>
                    setFieldValue("leadTypologyMapping", mapping)
                  }
                  onAmbiguityChange={setIsMappingAmbiguous}
                />
              </div>
            )}
            <div className="mt-16">
              <Button
                type="primary"
                size="full--width"
                disabled={submitting || isMappingAmbiguous}
                onClick={handleSubmit}
              >
                {FORM.SUBMIT}
              </Button>
            </div>
          </>
        )}
      </Formik>
    </Drawer>
  );
};

FormDrawer.propTypes = {
  source: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

FormDrawer.defaultProps = {
  source: null,
  submitting: false,
};

export default FormDrawer;
